export interface GlossaryTerm {
  abbr: string;
  full: string;
  note?: string;
}

export class PageFooter {
  static render(terms: GlossaryTerm[]): string {
    if (!terms.length) return '';

    const items = terms.map(t => `
      <div class="glossary-term">
        <span class="glossary-abbr">${t.abbr}</span>
        <span class="glossary-sep">—</span>
        <span class="glossary-full">${t.full}${t.note ? `<span class="glossary-note"> (${t.note})</span>` : ''}</span>
      </div>
    `).join('');

    return `
      <div class="page-footer-glossary">
        <div class="glossary-heading">Glossary</div>
        <div class="glossary-grid">
          ${items}
        </div>
      </div>
    `;
  }
}
